import React, { useState } from 'react';
import Loading from '../../../../Components/Loading';
import usePatientMedicalHistory, {
	MedicalHistoryItem,
} from '../../Hooks/usePatientMedicalHistory';
import { useEffectAsync } from '../../../../helpers';
import useRestApiClient from '../../../Base/Hooks/useRestApiClient';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	patientId: string;
	data: Record<string, string>;
}

const PatientMedicalHistoryAddData: React.FC<Props> = ({ patientId, data }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isSuccessfullyUpdated, setIsSuccessfullyUpdated] =
		useState<boolean>(false);
	const {
		isLoading: isLoadingMedicalHistory,
		updateMedicalHistory,
		medicalHistoryDocumentId,
		medicalHistory,
	} = usePatientMedicalHistory(patientId);
	const { processResult } = useRestApiClient();

	const convertMedicalHistoryToRecord = (
		data: MedicalHistoryItem[],
	): Record<string, string> => {
		return data.reduce<Record<string, string>>((acc, item) => {
			acc[item.key] = item.value;
			return acc;
		}, {});
	};

	useEffectAsync(async () => {
		setIsLoading(true);
		if (medicalHistory.length > 0 && medicalHistoryDocumentId) {
			const medicalHistoryData = convertMedicalHistoryToRecord(medicalHistory);
			const updatedMedicalHistory = {
				...medicalHistoryData,
				...data,
			};
			const response = await updateMedicalHistory(updatedMedicalHistory);
			if (response) {
				processResult(response, () => {
					setIsSuccessfullyUpdated(true);
				});
			}
		}
		setIsLoading(false);
	}, [patientId, data, medicalHistoryDocumentId, medicalHistory]);

	if (isLoading || isLoadingMedicalHistory) {
		return <Loading />;
	}

	if (isSuccessfullyUpdated) {
		return <Text tx='component.patientMedicalHistoryAddData.successMessage' />;
	}

	return <Text tx='component.patientMedicalHistoryAddData.problemMessage' />;
};

export default PatientMedicalHistoryAddData;
